import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { AnimateOnScroll } from './AnimateOnScroll';

const JobMarketplaceCTA = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: 'Mic',
      title: 'AI Voice Screening',
      description: 'Automated 24h voice interview evaluation with instant candidate scoring.',
      color: 'text-amber-500',
      bgColor: 'bg-amber-500/10 border-amber-500/20',
    },
    {
      icon: 'Zap',
      title: 'Walk-in Hiring Drives',
      description: 'Live panel queue assignment & instant on-site interview check-in.',
      color: 'text-blue-500',
      bgColor: 'bg-blue-500/10 border-blue-500/20',
    },
    {
      icon: 'CheckCircle2',
      title: 'Real-Time Tracking',
      description: 'Direct candidate application pipeline status with automated HR updates.',
      color: 'text-emerald-500',
      bgColor: 'bg-emerald-500/10 border-emerald-500/20',
    },
  ];

  return (
    <section className="bg-slate-100 dark:bg-slate-900/60 border-y border-border/60 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <AnimateOnScroll>
          <div className="text-center mb-12 md:mb-16">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 bg-amber-500/10 border border-amber-500/20 rounded-full mb-3">
              <Icon name="Briefcase" size={15} className="text-amber-500" />
              <span className="text-xs md:text-sm font-bold tracking-widest text-amber-600 dark:text-amber-400 uppercase">
                CAREER & TALENT MARKETPLACE
              </span>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground tracking-tight mb-3">
              Connect With High-Impact Roles & AI Screening
            </h2>
            <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto font-normal">
              Explore thousands of open opportunities across top enterprises or access pre-screened technical talent instantly.
            </p>
          </div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-12">
          {features.map((feat, index) => (
            <AnimateOnScroll key={feat.title} delay={index * 100}>
              <div className="bg-card rounded-2xl p-6 md:p-8 border border-border/80 hover:border-amber-500/40 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1.5 flex flex-col justify-between h-full group">
                <div>
                  <div className={`w-12 h-12 rounded-xl ${feat.bgColor} border flex items-center justify-center mb-5 group-hover:scale-105 transition-transform`}>
                    <Icon name={feat.icon} size={22} className={feat.color} />
                  </div>
                  <h3 className="text-lg font-bold text-foreground mb-2 group-hover:text-primary transition-colors">
                    {feat.title}
                  </h3>
                  <p className="text-xs md:text-sm text-muted-foreground leading-relaxed">
                    {feat.description}
                  </p>
                </div>
              </div>
            </AnimateOnScroll>
          ))}
        </div>

        <AnimateOnScroll delay={300}>
          <div className="text-center">
            <Button
              variant="default"
              size="lg"
              onClick={() => navigate('/job-marketplace')}
              iconName="ArrowRight"
              iconPosition="right"
              className="px-8 py-3.5 rounded-xl bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-slate-950 font-extrabold shadow-lg shadow-amber-500/20 hover:shadow-amber-500/35 border-0"
            >
              Browse Open Roles
            </Button>
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
};

export default JobMarketplaceCTA;
